export default __webpack_public_path__ + "static/media/PickGoogotype.95a096e3.png";